import { observer } from 'mobx-react-lite'
import { useOutletContext } from 'react-router'
import { MergeAccountsScreenContainer } from '@/features/admin/account-linking/MergeAccountsScreen/MergeAccountsScreenContainer'
import { type AdminViewModel } from '@/features/admin/AdminViewModel'

export default observer(function AdminMergeRequestsContainer() {
  const vm = useOutletContext<AdminViewModel>()
  return <MergeAccountsScreenContainer vm={vm.accountMergeRequestsVm} />
})
